import { ArrowUp, ArrowDown, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import Uploader from "@/admin/Uploader";
import { KIND, fmtSize } from "@/admin/ui";

const ACCEPT = { video: "video/*", audio: "audio/*", pdf: "application/pdf" };

export default function ResourceSlot({ slot, ids, files, onChange, onFileAdded, testid }) {
  const byId = Object.fromEntries(files.map((f) => [f.id, f]));
  const full = ids.length >= slot.max;
  const available = files.filter((f) => f.kind === slot.kind && !ids.includes(f.id));
  const move = (i, d) => { const n = [...ids]; [n[i], n[i + d]] = [n[i + d], n[i]]; onChange(n); };
  const add = (id) => onChange((cur) => (slot.max === 1 ? [id] : [...cur.filter((x) => x !== id), id].slice(0, slot.max)));
  return (
    <div className="adm-lesson" style={{ marginBottom: 0 }} data-testid={testid}>
      <div className="adm-panel-h" style={{ marginBottom: ".5rem" }}>
        <h2 style={{ fontSize: 14 }}>{slot.label}</h2>
        <span className="adm-sub" data-testid={`${testid}-count`}>{ids.length} de {slot.max}</span>
      </div>
      {!ids.length && <div className="adm-sub" style={{ marginBottom: ".6rem" }}>Sin archivo. En la web se muestra un aviso de «pronto».</div>}
      {ids.map((id, i) => (
        <div key={id} className="adm-list-item" data-testid={`${testid}-file-${i}`}>
          <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>{byId[id]?.name || "Archivo"}
            <div className="adm-sub">{KIND[byId[id]?.kind] || ""} {byId[id] ? `· ${fmtSize(byId[id].size)}` : ""}</div></span>
          <span className="adm-row" style={{ flexWrap: "nowrap", gap: ".3rem" }}>
            {slot.max > 1 && <>
              <button className="adm-btn sm" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Subir" data-testid={`${testid}-up-${i}`}><ArrowUp size={13} /></button>
              <button className="adm-btn sm" disabled={i === ids.length - 1} onClick={() => move(i, 1)} aria-label="Bajar" data-testid={`${testid}-down-${i}`}><ArrowDown size={13} /></button>
            </>}
            <button className="adm-btn sm" onClick={() => onChange(ids.filter((x) => x !== id))} aria-label="Quitar" data-testid={`${testid}-remove-${i}`}><X size={13} /></button>
          </span>
        </div>
      ))}
      {(!full || slot.max === 1) && (
        <div style={{ marginTop: ".6rem", display: "grid", gap: ".6rem" }}>
          {available.length > 0 && (
            <Select value="" onValueChange={add}>
              <SelectTrigger className="bg-white" data-testid={`${testid}-pick`}><SelectValue placeholder={slot.max === 1 && ids.length ? "Reemplazar desde la biblioteca" : "Añadir desde la biblioteca"} /></SelectTrigger>
              <SelectContent>{available.map((f) => <SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}</SelectContent>
            </Select>
          )}
          <Uploader accept={ACCEPT[slot.kind]} label={`Subir ${KIND[slot.kind].toLowerCase()}`} hint={`Solo ${KIND[slot.kind]} · máximo 600 MB`}
            testid={`${testid}-uploader`} onUploaded={(f) => { onFileAdded(f); if (f.kind === slot.kind) add(f.id); }} />
        </div>
      )}
    </div>
  );
}
